// extracted by mini-css-extract-plugin
export default {"edge":"MultiSlider_edge__OyDIS","leftEdge":"MultiSlider_leftEdge__G7NmP","rightEdge":"MultiSlider_rightEdge__RI0Lt","sliderStyle":"MultiSlider_sliderStyle__nQrYg"};